import React from 'react'

export interface TranslationContextValue {
  lang: string
  __: (key: string, ...args: (string | number)[]) => string
}

const TranslationContext = React.createContext<TranslationContextValue>({
  lang: 'en',
  // Default (no-provider) fallback: return the English key, but still resolve %s/%d placeholders
  // in order — mirroring TranslationProvider's own missing-key fallback — so a component rendered
  // outside a provider shows "Maximum 250 characters reached", not a literal "Maximum %d ...".
  __: (key, ...args) => {
    if (typeof key !== 'string') return key == null ? '' : String(key)
    if (!args.length) return key
    return key.replaceAll(/%s|%d/g, () => String(args.shift() ?? ''))
  }
})

export default TranslationContext
